/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../generated/graphqlTypes";

import { gql } from "@apollo/client";
import {
  UserPermissionFragmentDoc,
  GroupPermissionFragmentDoc,
} from "./permissions.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type CollectionGrantFragment = {
  readonly __typename: "CollectionGrant";
  readonly id: c.CollectionGrantId;
  readonly role: Types.CollectionRole;
  readonly holder:
    | {
        readonly __typename: "Group";
        readonly groupId: c.GroupId;
        readonly groupName: string;
      }
    | {
        readonly __typename: "IntrinsicGroup";
        readonly intrinsicGroupId: Types.IntrinsicGroupId;
      }
    | {
        readonly __typename: "User";
        readonly name: string | null;
        readonly email: string;
        readonly active: boolean;
        readonly imageUrl: string | null;
        readonly orgRole: Types.OrgRole;
        readonly userId: c.UserId;
      };
};

export type SafeCollectionHexLinkFragment = {
  readonly __typename: "CollectionHexLink";
  readonly id: c.CollectionHexLinkId;
  readonly projectRole: Types.ProjectRole | null;
  readonly collection: {
    readonly __typename: "Collection";
    readonly id: c.CollectionId;
    readonly canManage: boolean;
    readonly name: string;
    readonly emoji: string | null;
    readonly description: string | null;
    readonly collectionGrants: ReadonlyArray<{
      readonly __typename: "CollectionGrant";
      readonly id: c.CollectionGrantId;
      readonly role: Types.CollectionRole;
      readonly holder:
        | {
            readonly __typename: "Group";
            readonly groupId: c.GroupId;
            readonly groupName: string;
          }
        | {
            readonly __typename: "IntrinsicGroup";
            readonly intrinsicGroupId: Types.IntrinsicGroupId;
          }
        | {
            readonly __typename: "User";
            readonly name: string | null;
            readonly email: string;
            readonly active: boolean;
            readonly imageUrl: string | null;
            readonly orgRole: Types.OrgRole;
            readonly userId: c.UserId;
          };
    }>;
  };
};

export type ShareHexWithCollectionsMutationVariables = Types.Exact<{
  hexId: Types.Scalars["HexId"]["input"];
  appUserCollectionIds:
    | ReadonlyArray<Types.Scalars["CollectionId"]["input"]>
    | Types.Scalars["CollectionId"]["input"];
  viewerCollectionIds:
    | ReadonlyArray<Types.Scalars["CollectionId"]["input"]>
    | Types.Scalars["CollectionId"]["input"];
  editorCollectionIds:
    | ReadonlyArray<Types.Scalars["CollectionId"]["input"]>
    | Types.Scalars["CollectionId"]["input"];
  ownerCollectionIds:
    | ReadonlyArray<Types.Scalars["CollectionId"]["input"]>
    | Types.Scalars["CollectionId"]["input"];
  noAddedGrantCollectionIds:
    | ReadonlyArray<Types.Scalars["CollectionId"]["input"]>
    | Types.Scalars["CollectionId"]["input"];
}>;

export type ShareHexWithCollectionsMutation = {
  readonly __typename: "Mutation";
  readonly addCollectionsToHex: {
    readonly __typename: "Hex";
    readonly id: c.HexId;
    readonly logicViewIsShared: boolean;
    readonly isShared: boolean;
    readonly collectionHexLinks: ReadonlyArray<{
      readonly __typename: "CollectionHexLink";
      readonly id: c.CollectionHexLinkId;
      readonly projectRole: Types.ProjectRole | null;
      readonly collection: {
        readonly __typename: "Collection";
        readonly id: c.CollectionId;
        readonly canManage: boolean;
        readonly name: string;
        readonly emoji: string | null;
        readonly description: string | null;
        readonly collectionGrants: ReadonlyArray<{
          readonly __typename: "CollectionGrant";
          readonly id: c.CollectionGrantId;
          readonly role: Types.CollectionRole;
          readonly holder:
            | {
                readonly __typename: "Group";
                readonly groupId: c.GroupId;
                readonly groupName: string;
              }
            | {
                readonly __typename: "IntrinsicGroup";
                readonly intrinsicGroupId: Types.IntrinsicGroupId;
              }
            | {
                readonly __typename: "User";
                readonly name: string | null;
                readonly email: string;
                readonly active: boolean;
                readonly imageUrl: string | null;
                readonly orgRole: Types.OrgRole;
                readonly userId: c.UserId;
              };
        }>;
      };
    }>;
  };
};

export const CollectionGrantFragmentDoc = /*#__PURE__*/ gql`
  fragment CollectionGrantFragment on CollectionGrant {
    id
    role
    holder {
      ... on User {
        userId: id
        ...UserPermissionFragment
      }
      ... on Group {
        groupId: id
        ...GroupPermissionFragment
      }
      ... on IntrinsicGroup {
        intrinsicGroupId: id
      }
    }
  }
  ${UserPermissionFragmentDoc}
  ${GroupPermissionFragmentDoc}
`;
export const SafeCollectionHexLinkFragmentDoc = /*#__PURE__*/ gql`
  fragment SafeCollectionHexLinkFragment on CollectionHexLink {
    id
    projectRole
    collection {
      id
      canManage
      name
      emoji
      description
      collectionGrants {
        id
        ...CollectionGrantFragment
      }
    }
  }
  ${CollectionGrantFragmentDoc}
`;
export const ShareHexWithCollectionsDocument = /*#__PURE__*/ gql`
  mutation ShareHexWithCollections(
    $hexId: HexId!
    $appUserCollectionIds: [CollectionId!]!
    $viewerCollectionIds: [CollectionId!]!
    $editorCollectionIds: [CollectionId!]!
    $ownerCollectionIds: [CollectionId!]!
    $noAddedGrantCollectionIds: [CollectionId!]!
  ) {
    addCollectionsToHex(
      hexId: $hexId
      appUserCollectionIds: $appUserCollectionIds
      viewerCollectionIds: $viewerCollectionIds
      editorCollectionIds: $editorCollectionIds
      ownerCollectionIds: $ownerCollectionIds
      noAddedGrantCollectionIds: $noAddedGrantCollectionIds
    ) {
      id
      logicViewIsShared
      isShared
      collectionHexLinks: safeCollectionHexLinks {
        id
        ...SafeCollectionHexLinkFragment
      }
    }
  }
  ${SafeCollectionHexLinkFragmentDoc}
`;
export type ShareHexWithCollectionsMutationFn = Apollo.MutationFunction<
  ShareHexWithCollectionsMutation,
  ShareHexWithCollectionsMutationVariables
>;

/**
 * __useShareHexWithCollectionsMutation__
 *
 * To run a mutation, you first call `useShareHexWithCollectionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareHexWithCollectionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareHexWithCollectionsMutation, { data, loading, error }] = useShareHexWithCollectionsMutation({
 *   variables: {
 *      hexId: // value for 'hexId'
 *      appUserCollectionIds: // value for 'appUserCollectionIds'
 *      viewerCollectionIds: // value for 'viewerCollectionIds'
 *      editorCollectionIds: // value for 'editorCollectionIds'
 *      ownerCollectionIds: // value for 'ownerCollectionIds'
 *      noAddedGrantCollectionIds: // value for 'noAddedGrantCollectionIds'
 *   },
 * });
 */
export function useShareHexWithCollectionsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ShareHexWithCollectionsMutation,
    ShareHexWithCollectionsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ShareHexWithCollectionsMutation,
    ShareHexWithCollectionsMutationVariables
  >(ShareHexWithCollectionsDocument, options);
}
export type ShareHexWithCollectionsMutationHookResult = ReturnType<
  typeof useShareHexWithCollectionsMutation
>;
export type ShareHexWithCollectionsMutationResult =
  Apollo.MutationResult<ShareHexWithCollectionsMutation>;
export type ShareHexWithCollectionsMutationOptions = Apollo.BaseMutationOptions<
  ShareHexWithCollectionsMutation,
  ShareHexWithCollectionsMutationVariables
>;
